module.exports = __webpack_public_path__ + "static/img/3051_phase_function_Paper_PointsHejduk_Prediction.8737182.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3051_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jdYy
// module chunks = 0